<template>
  <div>
    <div class="approve-content-wrap" v-for="item in approData" :key="item.id" @click="goApproDetail(item)">
      <div class="leader-wrap">
        <img v-if="item.startUserPic" class="head-icon" :src="item.startUserPic"/>
        <span v-if="!item.startUserPic">{{item.startUserName.substr(0, 1)}}</span>
      </div>
      <div class="p-container-wrap">
        <div class="p-top-content">
          <div class="p-approve-person" :title="item.startUserName">{{ item.startUserName }}</div>
          <div class="p-approve-type">
            <template v-if="approListData.isMatterList.indexOf(item.approType) > -1">
              <em class="approval-icon ibass ibass-project-type1"  v-if="item.pMatterType === '0'"></em>
              <em class="approval-icon ibass ibass-project-type2" v-if="item.pMatterType ==='1'"></em>
              <em class="approval-icon ibass ibass-project-type3" v-if="item.pMatterType === '2'"></em>
              <em class="approval-icon ibass ibass-project-type4" v-if="item.pMatterType === '3'"></em>
            </template>
            <em class="arroval-icon" v-if="approListData.isMatterList.indexOf(item.approType) === -1 && item.icon" :class="'icon-' + item.icon || 'ibass-project'"></em>
            <em class="arroval-icon" v-if="approListData.isMatterList.indexOf(item.approType) === -1 && !item.icon" :class="approListData.typeInfos[item.approType]&&approListData.typeInfos[item.approType].icon"></em>
            <div class="p-appro-name">{{approListData.isApproList.indexOf(item.approType) > -1 ? item.approTypeName.substr(0,item.approTypeName.length -2) : item.approTypeName}}</div>
            <!--旧所审批类型-->
            <!--<span v-if="isNewFirm !== 'newVersion'" class="p-appro-name">{{approListData.typeInfos[item.approType].name}}</span>-->
          </div>
        </div>
        <div class="p-approve-title" :title="item.outlook">
          {{ item.outlook }}
        </div>
        <div class="p-bottom-content">
          <template v-if="isNewFirm === 'newVersion'">
            <div class="p-decline">当前节点: {{item.nodeName}}</div>
            <div class="p-approve-date">发起日期：{{item.createDate}}</div>
            <div class="p-arrive-date">到达当前节点日期: {{item.arriveCurrentNodeDate}}</div>
          </template>
          <template v-else>
            <div class="p-approve-date">日期：{{item.createDate}}</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TodoApprove',
  props: {
    approData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isNewFirm: '',
      approListData: {
        isMatterList: [10, 9, 8, 5, 7, 3, 6],
        isApproList: [10, 9, 8, 5, 7, 3, 6, 4, 2, 1, 0],
        typeInfos: {
          1: {
            type: '1',
            name: '发票',
            icon: 'ibass ibass-approve-Invoice',
            desc: '发票审批'
            // color: 'rgb(74, 144, 226)'
          },
          2: {
            type: '2',
            name: '报销',
            icon: 'ibass ibass-approve-reimburse',
            desc: '报销审批'
            // color: 'rgb(72, 169, 124)'
          },
          3: {
            type: '3',
            name: '结项',
            icon: 'ibass ibass-project-type1',
            desc: '结项审批'
            // color: '#ff5469'
          },
          4: {
            type: '4',
            name: '合同',
            icon: 'ibass ibass-contract',
            desc: '合同审批'
            // color: 'rgb(255, 93, 113)'
          },
          5: {
            type: '5',
            name: '立项',
            icon: 'ibass ibass-project-type1',
            desc: '立项审批'
            // color: '#ff5469'
          },
          6: {
            type: '6',
            name: '重启项目',
            icon: 'ibass ibass-project-type1',
            desc: '重启项目审批'
            // color: '#ff5469'
          },
          7: {
            type: '7',
            name: '编辑项目',
            icon: 'ibass ibass-project-type1',
            desc: '编辑项目审批'
            // color: '#ff5469'
          },
          8: {
            type: '8',
            name: '预立项',
            icon: 'ibass ibass-project-type1',
            desc: '预立项审批'
            // color: '#ff5469'
          },
          9: {
            type: '9',
            name: '编辑预立项',
            icon: 'ibass ibass-project-type1',
            desc: '编辑预立项审批'
            // color: '#ff5469'
          },
          10: {
            type: '10',
            name: '预立项转进行中',
            icon: 'ibass ibass-project-type1',
            desc: '预立项转进行中审批'
            // color: '#ff5469'
          },
          11: {
            type: '11',
            name: '删除项目审批',
            icon: 'ibass ibass-project-type1',
            desc: '删除项目审批'
            // color: '#ff5469'
          },
          12: {
            type: '12',
            name: '批量立项审批',
            icon: 'ibass ibass-project-type1',
            desc: '批量立项审批'
            // color: '#ff5469'
          },
          0: {
            type: '0',
            name: '盖章',
            icon: 'ibass ibass-approve-stamp',
            desc: '盖章审批'
            // color: 'rgb(255, 93, 113)'
          },
          16: {
            type: '16',
            name: '批量编辑项目',
            icon: 'ibass ibass-project-type1',
            desc: '批量编辑项目审批'
             // color: '#ff5469'
          },
          15: {
            type: '15',
            name: '归档卷宗借阅',
            icon: 'ibass ibass-project-type1',
            desc: '归档卷宗借阅审批'
            // color: '#ff5469',
          },
          14: {
            type: '14',
            name: '归档',
            icon: 'ibass ibass-project-type1',
            desc: '归档审批'
            // color: '#ff5469',
          },
          13: {
            type: '13',
            name: '完成任务',
            icon: 'ibass ibass-task-pad',
            desc: '完成任务审批'
            // color: '#fa8919',
          }
        }
      }
    }
  },
  methods: {
    goApproDetail (appro) {
      window.parent.postMessage({
        action: 'fromWorkFlatApprovalDetail',
        data: {
          approvalId: appro.id,
          approType: appro.approType
        }
      }, process.env.VUE_APP_IFRAME_DOMAIN)
      this.$analysis.track('查看审批详情_待办事项/工作台模块')
    }
  },
  mounted () {
    this.isNewFirm = localStorage.officeVersion
  }
}
</script>

<style lang="stylus" scoped>
  .approve-content-wrap {
    width 100%;
    padding 15px 0
    box-sizing border-box;
    display flex;
    justify-content space-between;
    cursor pointer;
    border-bottom 1px solid #f1f2f3

    .leader-wrap {
        width 32px;
        height 32px;
        border-radius: 50%;
        overflow: hidden;
        background-color #fdba78
        margin-right 16px;
        font-size: 18px;
        text-align: center;
        line-height: 32px;
        color: #fff;
        .head-icon {
          width 100%;
          /*height 100%;*/
          /*border-radius 50%;*/
          /*background-color #f3f3f3;*/
        }
    }
    .p-container-wrap {
      padding-top 6px
      flex-grow 1;
      display flex;
      flex-direction column;
      .p-top-content {
        display flex;
        /*justify-content space-between;*/
        align-items center;
        .p-approve-type {
          width 155px;
          color #666;
          font-size 12px
          .p-appro-name {
            display inline-block;
          }
          em {
            font-size 12px
            vertical-align -1px
            margin-right 4px
            color #666
          }
          .icon-val {
            font-size 15px
            vertical-align -2px
          }
        }
      }
      .p-approve-title {
        flex-grow 1;
        margin-top 8px
        font-size 16px;
        color #000000;
        max-width 620px;
        overflow hidden;
        text-overflow ellipsis;
        white-space nowrap;
        &:hover {
          color #ed6c00
        }
      }
      .p-bottom-content {
        margin-top 3px
        display flex;
        /*justify-content space-between;*/
        align-items center;
        font-size 12px;
        color #8590a6
        .p-decline {
          margin-right 20px;
          width 180px
          overflow hidden;
          text-overflow ellipsis;
          white-space nowrap;
        }
        .p-approve-date {
          margin-right 40px
        }
      }
      .p-approve-person {
        margin-right 15px;
        width 72px;
        font-size 12px
        color #000
        overflow hidden;
        text-overflow ellipsis;
        white-space nowrap;
      }
    }
  }

</style>
